import './carrier-overview.scss';
import CarrierOverview from './carrier-overview';

export default CarrierOverview;
